import React, { useState } from 'react';
import { Form, Input, Button } from 'semantic-ui-react';

const SearchBar = ({ onSearch }) => {
  const [searchType, setSearchType] = useState('macAddress');
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    setLoading(true);
    if (!searchValue) {
      await onSearch();
    }
    switch (searchType) {
      case 'macAddress':
        await onSearch({ macAddress: searchValue });
        break;
      case 'model':
        await onSearch({ model: searchValue });
        break;
    }
    setLoading(false);
  };

  return (
    <Form>
      <div style={{ display: 'flex', gap: '8px', height: 40 }}>
        <Form.Select
          value={searchType}
          onChange={(e, { value }) => setSearchType(value)}
          options={['macAddress', 'model'].map((m) => ({
            key: m,
            text: 'Search by ' + m,
            value: m,
          }))}
        />
        <Form.Field>
          <Input
            placeholder={`Search by ${searchType}`}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            style={{ width: 400 }}
          />
        </Form.Field>
        <Button
          primary
          onClick={handleSearch}
          loading={loading}
          style={{ left: 0, height: 40, top: 0 }}
        >
          Search
        </Button>
      </div>
    </Form>
  );
};

export default SearchBar;
